export default __webpack_public_path__ + "static/media/2.04c27fde.JPG";